import { Injectable, TemplateRef, inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { filter, map } from 'rxjs';

import { InputCheckBox, InputChoices, InputPanel, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues, isNonNullable } from '@camelot/utils';

import { CamColorSetsService } from '../color-set.service';
import { NoteType, NoteTypeCreationPayloadInput, NoteTypeModifierPayloadInput } from '../dto/note-type';

enum ENoteTypeFormFields {
  denomination = 'denomination',
  isActive = 'isActive',
  colorSetId = 'colorSetId',
}

@Injectable({
  providedIn: 'root',
})
export class CamNoteTypeFormService {
  private _colorSetsService = inject(CamColorSetsService);

  constructor() {
    this._colorSetsService.fetchColorSets$().subscribe();
  }

  public getNoteTypeForm(noteType: NoteType | null, colorSetTemplate: TemplateRef<any>) {
    return [
      new InputPanel({
        key: 'panel',
        contentClass: 'highlight-title g-space-md',
        children: [
          new InputTextBox({
            key: ENoteTypeFormFields.denomination,
            value: noteType?.denomination,
            label: 'noteTypes.form.denomination',
            validators: [Validators.required],
          }),
          new InputChoices({
            key: ENoteTypeFormFields.colorSetId,
            value: noteType?.colorSetId ? [noteType?.colorSetId] : [],
            label: 'noteTypes.form.backgroundColor',
            choiceTemplate: { one: colorSetTemplate },
            validators: [Validators.required],
            multiple: false,
            options: this._colorSetsService.colorSets.get$().pipe(
              filter(isNonNullable),
              map(colorSets =>
                colorSets.map(colorSet => ({
                  id: colorSet.id,
                  name: colorSet.id,
                  data: colorSet,
                }))
              )
            ),
          }),
          new InputCheckBox({
            key: ENoteTypeFormFields.isActive,
            label: 'noteTypes.form.active',
            class: 'pt-xxl',
            value: noteType?.isActive,
            toggle: true,
          }),
        ],
      }),
    ];
  }

  public noteTypeCreateFormatForm(data: any): NoteTypeCreationPayloadInput {
    return {
      denomination: data[ENoteTypeFormFields.denomination] ?? null,
      isActive: data[ENoteTypeFormFields.isActive] ?? null,
      colorSetId: data[ENoteTypeFormFields.colorSetId][0] ?? null,
    };
  }
  public noteTypeUpdateFormatForm(data: any, noteType: NoteType): Partial<NoteTypeModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, noteType);
    return {
      ...{
        denomination: modifiedData[ENoteTypeFormFields.denomination] ?? null,
        isActive: data[ENoteTypeFormFields.isActive] ?? null,
        colorSetId: data[ENoteTypeFormFields.colorSetId][0] ?? null,
      },
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
